import { adjustContentVisibility, Section } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';
import { Subtitle, Title } from './shared/ContentStyling';
// logos
import org350 from '@/static/assets/bottom-logos/350org.svg';
import ACLU from '@/static/assets/bottom-logos/ACLU.svg';
import AmericanForests from '@/static/assets/bottom-logos/AmericanForests.svg';
import AmericanRedCross from '@/static/assets/bottom-logos/AmericanRedCross.svg';
import BornThisWayFoundation from '@/static/assets/bottom-logos/BornThisWayFoundation.svg';
import CharityWater from '@/static/assets/bottom-logos/CharityWater.svg';
import Cure from '@/static/assets/bottom-logos/Cure.svg';
import DirectRelief from '@/static/assets/bottom-logos/DirectRelief.svg';
import MalalaFund from '@/static/assets/bottom-logos/MalalaFund.svg';
import MarchForOurLives from '@/static/assets/bottom-logos/MarchForOurLives.svg';
import NewStory from '@/static/assets/bottom-logos/NewStory.svg';
import TechForAmerica from '@/static/assets/bottom-logos/TechForAmerica.svg';
import TheTrevorProject from '@/static/assets/bottom-logos/TheTrevorProject.svg';
import ToWriteLoveOnHerArms from '@/static/assets/bottom-logos/ToWriteLoveOnHerArms.svg';

const LOGOS = [
  { image: DirectRelief, alt: 'Direct Relief' },
  { image: BornThisWayFoundation, alt: 'Born This Way Foundation' },
  { image: ToWriteLoveOnHerArms, alt: 'To Write Love On Her Arms' },
  { image: MalalaFund, alt: 'Malala Fund' },
  { image: CharityWater, alt: 'Charity Water' },
  { image: Cure, alt: 'Cure' },
  { image: NewStory, alt: 'New Story' },
  { image: AmericanForests, alt: 'American Forests' },
  { image: AmericanRedCross, alt: 'American Red Cross' },
  { image: TechForAmerica, alt: 'Tech For America' },
  { image: org350, alt: 'org350' },
  { image: ACLU, alt: 'ACLU' },
  { image: MarchForOurLives, alt: 'March For Our Lives' },
  { image: TheTrevorProject, alt: 'The Trevor Project' },
];

const StyledTitle = styled(Title)`
  padding: 0 20px;
  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: normal
  `}
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export interface BottomLogosProps {
  title: string;
  subtitle: string;
}

const BottomLogos: React.FC<BottomLogosProps> = ({ title, subtitle }) => {
  return (
    <StyledSection
      width="100%"
      alignItems="center"
      textAlign="center"
      flexDirection="column"
      pb={[40, 70]}
      pt={[40, 70]}
      darkBackground
    >
      <StyledTitle zIndex={2} tabIndex={0}>
        {parse(title)}
      </StyledTitle>
      <Subtitle px={[20, 0, 0]} pt={20} tabIndex={0}>
        {parse(subtitle)}
      </Subtitle>
      <Flex flexWrap="wrap" width="100%" maxWidth="800px" justifyContent="center" mt={40} gap="20px">
        {LOGOS.map(({ image, alt }) => (
          <Image key={alt} src={image} alt={alt} style={{ pointerEvents: 'none' }} />
        ))}
      </Flex>
    </StyledSection>
  );
};

export default BottomLogos;
